module.exports = __webpack_public_path__ + "img/pipe_tjunction.c624ca85.svg";